module.exports = __webpack_public_path__ + "static/img/sg1.172469c.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/mobile_img/role3/control2/sg1.png
// module id = DsRJ
// module chunks = 7